export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Manager',
  hero_title_ja: 'AIX マネージャー',
  hero_desc: 'AI導入後の運用・管理から業務自動化・データ活用まで、\n組織のデジタル変革を継続的に伴走支援します。',
  overview_label: 'OVERVIEW',
  overview_title: 'サービス概要',
  overview_desc: 'AIX Managerは、AI導入後の「使いこなせない」「定着しない」「成果が出ない」といった課題を解消するためのAI運用・管理支援サービスです。\n\n業務自動化の推進からデータ活用基盤の構築、組織横断的な変革マネジメントまで、導入後のすべてのフェーズで専任チームが伴走。AIと人が共存する、持続可能なデジタル組織への変革を支援します。',
  services_label: 'SERVICES',
  services_title: '主なサービス内容',
  service_1_title: 'AI導入・運用管理',
  service_1_desc: 'AI導入後の運用設計・管理体制の構築を支援。ツール選定から定着化まで、現場に根付いたAI活用の仕組みを整えます。',
  service_2_title: '業務自動化推進',
  service_2_desc: '繰り返し業務・データ処理・レポーティングなど、AIを活用した業務自動化を設計・実装。人的リソースを高付加価値業務へシフトさせます。',
  service_3_title: 'データ活用・分析基盤構築',
  service_3_desc: '社内に散在するデータを統合・整備し、意思決定に活かせる分析基盤を構築。ダッシュボード設計から運用定着までをサポートします。',
  service_4_title: '組織変革マネジメント',
  service_4_desc: 'AI・デジタルツールの導入に伴う組織変革を推進。現場の抵抗感を解消しながら、部門横断的なデジタル変革を継続的に支援します。',
  challenges_label: 'CHALLENGES',
  challenges_title: 'こんな課題を解決します',
  challenge_1: 'AI・ツールを導入したが現場に定着していない',
  challenge_2: '導入したAIのROIが見えず、活用が止まっている',
  challenge_3: 'データが社内に散在しており活用できていない',
  challenge_4: '業務自動化を進めたいが何から手をつければいいかわからない',
  challenge_5: '部門間のデータ連携・情報共有がうまくいっていない',
  challenge_6: '組織全体のデジタル変革が一部の担当者任せになっている',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'AIX JAPANが選ばれる理由',
  reason_1_title: '現状診断から始める安心感',
  reason_1_desc: '既存システム・業務フロー・データ資産を丁寧に診断した上で支援内容を設計。押しつけではなく、自社に合った最適解を提案します。',
  reason_2_title: '現場に根付いた変革支援',
  reason_2_desc: 'AI・ツール導入の抵抗感を解消するチェンジマネジメントも担当。担当者依存を脱し、組織全体がデジタルを使いこなせる体制を構築します。',
  reason_3_title: 'データ資産の最大活用',
  reason_3_desc: 'バラバラなデータを統合・整備し、ビジネス意思決定に直結する分析基盤を構築。データ活用文化の醸成まで支援します。',
  reason_4_title: '継続的な伴走モデル',
  reason_4_desc: '導入して終わりではなく、運用後のモニタリング・改善・拡張まで長期的に支援。成果を維持・拡大し続けるパートナーです。',
  auto_label: 'AUTOMATION',
  auto_title: '自動化できる業務の例',
  auto_subtitle: '貴社の課題に合わせてカスタマイズした自動化を設計・実装します',
  auto_1_title: '書類・レポート作成',
  auto_1_desc: '月次報告書・提案資料・議事録などの定型文書をAIが自動生成。作成時間を最大90%削減。',
  auto_2_title: 'メール・問い合わせ対応',
  auto_2_desc: '顧客問い合わせの自動分類・返信草案生成・エスカレーション振り分けを自動化。',
  auto_3_title: 'データ収集・集計',
  auto_3_desc: 'Webスクレイピング・API連携・CSV処理などのデータパイプラインを自動構築。',
  auto_4_title: '承認・ワークフロー',
  auto_4_desc: '申請・承認フローのデジタル化とAI判定による一次スクリーニングで処理スピードを向上。',
  auto_5_title: 'ダッシュボード・KPI管理',
  auto_5_desc: 'リアルタイムのKPIダッシュボードを自動更新。経営判断に必要な数字を即座に把握。',
  auto_6_title: 'カスタマーサポート',
  auto_6_desc: 'FAQチャットボット・問い合わせ分類・顧客対応履歴の自動整理で対応品質を向上。',
  flow_label: 'FLOW',
  flow_title: '導入の流れ',
  flow_intro: '現状診断から運用定着まで、各ステップの作業内容と成果物を明確にして進めます。期間は対象業務の範囲により変動するため、あくまで目安です。',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-search-eye-line',
      title: '現状診断',
      note: '初回相談無料',
      duration: '約2〜4週間',
      activities: [
        '既存システム・業務フロー・データ資産の調査',
        '自動化・データ活用の機会の洗い出しと費用対効果の見立て',
      ],
      deliverables: ['現状診断レポート', '自動化候補リスト（優先度付き）'],
      clientAsks: ['業務フロー資料・システム構成のご共有', '現場ヒアリングへのご協力'],
    },
    {
      no: '02',
      icon: 'ri-draft-line',
      title: '最適化設計',
      duration: '約2〜4週間',
      activities: [
        '業務自動化・データ活用・AI運用管理の全体設計',
        '優先順位・導入計画の策定、セキュリティ・権限の設計',
      ],
      deliverables: ['全体設計書', '導入計画書'],
      clientAsks: ['優先順位のご合意', '情報システム部門との調整窓口の設定'],
    },
    {
      no: '03',
      icon: 'ri-settings-4-line',
      title: '実装・自動化推進',
      duration: '約1〜3ヶ月',
      activities: [
        '自動化ワークフロー・分析基盤の実装と段階的リリース',
        '現場向けの導入トレーニング',
      ],
      deliverables: ['稼働する自動化ワークフロー・ダッシュボード', '操作手順書'],
      clientAsks: ['テスト運用への現場参加とフィードバック'],
    },
    {
      no: '04',
      icon: 'ri-loop-right-line',
      title: '継続的運用支援',
      duration: '継続（月次）',
      activities: [
        '稼働モニタリングと改善、対象業務の拡張設計',
        '社内推進体制の内製化支援',
      ],
      deliverables: ['運用レポート', '改善・拡張のご提案'],
      clientAsks: ['定例レビュー会（月1回程度）へのご参加'],
    },
  ],
};